interface FormErrorSummaryProps {
  errors?: Record<string, string[]>
  /** Optional lead-in shown above the list (draft uses one; manage does not). */
  title?: string
}

export function FormErrorSummary({ errors, title }: FormErrorSummaryProps) {
  const allErrors = errors ? Object.values(errors).flat() : []
  if (allErrors.length === 0) return null

  return (
    <div className="border-destructive/30 bg-destructive/10 mb-6 rounded-lg border p-4">
      {title && (
        <p className="text-destructive mb-2 text-sm font-semibold">{title}</p>
      )}
      <ul className="list-inside list-disc space-y-1">
        {allErrors.map((err, i) => (
          <li key={i} className="text-destructive text-sm">
            {err}
          </li>
        ))}
      </ul>
    </div>
  )
}
